import { Grid, Typography } from "@material-ui/core";
import GenericButton from "components/Buttons/GenericButton";
import GenericDialog from "components/Dialogs/GenericDialogV2";
import FormDropzoneField from "components/FormFields/FormDropzoneField";
import FormInputV2 from "components/FormFields/FormInputV2";

const CooperativeMemberInactivationModal = ({ methods, open, onClose, onSubmit, isSubmitting }) => (
  <GenericDialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <Typography
      style={{
        fontSize: "1.6rem",
        marginBottom: "2rem",
      }}
      variant="h2"
      color="primary"
    >
      Inactivar Membro da Cooperativa
    </Typography>

    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormInputV2
          name="inactivationReasonInput"
          label="Motivo de Inactivação"
          placeholder="Descreva o motivo da inactivação"
          control={methods.control}
          required
          multiline
          rows={4}
        />
      </Grid>

      <Grid item xs={12}>
        <FormDropzoneField
          accept="application/pdf"
          control={methods.control}
          label="Comprovativo de Inactivação"
          name="inactivationDocument"
          inputLabel="Adicionar documento"
          maxSize={2}
        />
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          gap: "1rem",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "1rem",
        }}
      >
        <GenericButton
          typeSubmit={false}
          size="medium"
          color="tertiary"
          onClick={onClose}
          disabled={isSubmitting}
        >
          CANCELAR
        </GenericButton>
        <GenericButton
          typeSubmit={false}
          size="medium"
          color="tertiaryRed"
          onClick={methods.handleSubmit(onSubmit)}
          disabled={isSubmitting}
          loading={isSubmitting}
        >
          CONFIRMAR INACTIVAÇÃO
        </GenericButton>
      </Grid>
    </Grid>
  </GenericDialog>
);

export default CooperativeMemberInactivationModal;